import React, { useState, useEffect } from "react";

import { TextField, Container, Button } from "@mui/material";
import { Typography, Box, Grid } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../../common/Buttons";
import {
  getHealthcareProxy,
  postHealthcareProxy,
} from "../../../../services/documentServices";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../../utils/Utilities";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const EmergencyFolder = (props) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [values, setValues] = useState([{ text: "" }]);
  const [isLoading, setIsLoading] = useState(false);
  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (
          result.payLoad.healthProxyEmergencies !== null &&
          result.payLoad.healthProxyEmergencies?.length > 0
        ) {
          setValues(result.payLoad.healthProxyEmergencies);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (values) => {
    const payload = {
      ...data,
      healthProxyEmergencies: [...values],
      healthEmergencyStepStatus: values[0].text ? 2 : 0,
    };
    const result = await postHealthcareProxy(payload, id);
    if (result?.success) {
      props.next();
    }
  };

  const addValue = () => {
    setValues([...values, { text: "" }]);
  };
  const handleValueChange = (index, e) => {
    const tempValues = [...values];
    tempValues[index].text = e.target.value;
    setValues(tempValues);
  };
  return (
    <>
      <form
        id="form_submit"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(values);
        }}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
        className="summary-table documents-card-height"
      >
        {isLoading ? (
          <Box component="div" className="loader-container">
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <Box sx={{ mt: 5, textAlign: "center" }}>
            <Typography
              sx={{ mt: 5 }}
              variant="p"
              paragraph
              align="left"
              color="color.black"
            >
              {t("additional-emergency-folder-text")}
            </Typography>
            {values.map((jump, index) => (
              <Box key={jump.text}>
                <TextField
                  variant="standard"
                  margin="dense"
                  value={jump.text}
                  onChange={(e) => handleValueChange(index, e)}
                  fullWidth
                />
              </Box>
            ))}

            <Typography sx={{ mt: 2, display: "flex" }}>
              <SecondaryButton
                title={
                  <>
                    <Typography
                      sx={{
                        fontWeight: 900,
                        fontSize: "1.5rem",
                        position: "absolute",
                        top: "-6%",
                        left: "7%",
                      }}
                    >
                      +
                    </Typography>{" "}
                    {t("add-line")}
                  </>
                }
                textTransform="initial"
                fontWeight="normal"
                bgColor="#DEDEDE"
                borderRadius="40px"
                padding="2px auto"
                width="230px"
                border="none"
                color="color.black"
                hoverBgColor="#DEDEDE"
                click={addValue}
              />
            </Typography>
          </Box>
        )}
      </form>
    </>
  );
};

export default EmergencyFolder;
